import { ThemeToggle } from '../components/ThemeToggle.js';

/**
 * 화이트리스트에 없는 IP 로 접속했을 때 보여준다.
 *
 * 예전엔 로그인 폼을 그대로 보여주고, 로그인을 시도해야만(POST /api/auth/login 이
 * middleware/ipWhitelist.ts 에 막혀) "접속이 허용되지 않았습니다" 를 알 수 있었다.
 * 로그인 버튼을 눌러도 결과가 같은 걸 미리 아는 게 나아서, AuthProvider 가
 * /api/auth/me 단계에서 이미 이 상태를 감지하면(ipBlocked) App.tsx 가 로그인 폼
 * 대신 이 화면을 그린다 - 아이디/비밀번호를 칠 필요조차 없다.
 */
export function IpBlockedPage() {
  return (
    <div className="login">
      <div className="login__theme-toggle">
        <ThemeToggle />
      </div>
      <div className="login__card">
        <h1 className="login__title">xadmin</h1>
        <div className="state state--error" role="alert">
          <strong>허용된 IP가 아닙니다</strong>
          <span>이 사이트는 등록된 IP에서만 접속할 수 있습니다. 관리자에게 화이트 IP 등록을 요청하세요.</span>
        </div>
      </div>
    </div>
  );
}
